import moment from 'moment'
export const state = {
    contaReceber: {
        cliente_id: '',
        situacao: 'EM ABERTO',
        numero_documento: '',
        data_vencimento: moment().format('YYYY-MM-DD'),
        data_vencimento_original: moment().format('YYYY-MM-DD'),
        data_emissao: moment().format('YYYY-MM-DD'),
        data_competencia: moment().format('YYYY-MM-DD'),
        forma_pagamento: '',
        ocorrencia_tipo: '',
        ocorrencia: 'PARCELA ÚNICA',
        ocorrencia_quantidade: 1,
        numero_parcela: 1,
        ocorrencia_quantidade: '',
        informacoes: '',
        anexo: '',
        portador_id: '',
        grupo_id: '',
    },
    contasReceber: [],
    contaReceberSituacoes: [
        '',
        'EM ABERTO',
        'PAGO'
    ],
    contaReceberPortadores: [
        'ADMINISTRADORA',
        'BANCO',
        'CAIXA'
    ],
    contaReceberFormasPagamento: [
        'DINHEIRO',
        'CARTÃO DE CRÉDITO',
        'CARTÃO DE DÉBITO',
        'CHEQUE',
        'BOLETO',
    ],

    contaReceberOcorrenciaTipos: [
        'PARCELA ÚNICA',
        'PARCELAR',
        // 'REPETIR'
    ],
    contaReceberOcorrencias: [
        'DIÁRIA',
        'SEMANAL',
        'MENSAL',
        'BIMESTRAL',
        'TRIMESTRAL',
        'SEMESTRAL',
        'ANUAL',
    ],
    modalExcluirContaReceber: false,
    modalCadastrarContaReceber: false,
    modalBaixaContaReceber: false,
    showInputAnexoContaReceber: true,
    modalReciboTotalContaReceber: false,
    modalReciboParcialContaReceber: false,
    movimentacaoExtratoContaReceber: {}
}

export default {}